import { render, staticRenderFns } from "./TheAddEditContactPanel.vue?vue&type=template&id=88fa69d2&scoped=true"
import script from "./TheAddEditContactPanel.vue?vue&type=script&lang=js"
export * from "./TheAddEditContactPanel.vue?vue&type=script&lang=js"
import style0 from "./TheAddEditContactPanel.vue?vue&type=style&index=0&id=88fa69d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fa69d2",
  null
  
)

export default component.exports